import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Container, Row, Col, Button } from 'reactstrap';
import Header from 'components/Headers/Header';

const TEMPLATES = [
  {
    name: 'Note Builder',
    features: [
      '<strong>Overview</strong>: Sync <em>unsigned or draft notes</em> to train the AI, and it will generate new notes<em> based on your examples</em>.',
      '<strong>When to Use</strong>: Must have access to <em>unsigned or draft notes in order to sync to system</em>.',
      '<strong>How It Works</strong>: To create a template, sync or copy and paste <em>at least 3 completed notes to train the system</em>.',
      '<strong>Works best with</strong>: <em>Empower, WebPT, Practice Pro, Jane</em> and others.',
      '<strong>Demo</strong>: <a href="https://comprehendpt.notion.site/How-to-Create-a-Custom-Template-19868e7a57a9808abb31efe9cf5f3d0b?pvs=4" target="_blank">Click here</a>',
    ],
    link: '/User/templates/builder',
  },
];

const ChooseTemplateBuilder = () => {
  const navigate = useNavigate();
  const formatFeature = (feature) => {
    return (
      <li
        className="feature-item"
        style={{ marginBottom: '5px' }}
        dangerouslySetInnerHTML={{ __html: feature }}
      />
    );
  };

  return (
    <>
      <Header isLite={true} />
      <Container className="mt--9" fluid>
        <Row className="justify-content-center">
          {TEMPLATES.map((template, index) => (
            <Col md="6" lg="4" className="my-3" key={template.name}>
              <Card
                className="custom-card h-100 d-flex flex-column shadow-lg" // Add shadow for visual appeal
                style={{ marginTop: '70px' }} // Move the card slightly below
              >
                <div className="card-body">
                  <h3
                    className="choose-card-title"
                    style={{
                      fontSize: '1.5rem',
                      color: '#222',
                      fontWeight: 'bold',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: '10px',
                    }}
                  >
                    {template.name}
                    {/* {index === 0 && (
                      <span
                        style={{
                          backgroundColor: '#5e72e4',
                          color: 'white',
                          padding: '5px 10px',
                          borderRadius: '20px',
                          fontSize: '0.7rem',
                        }}
                      >
                        Recommended
                      </span>
                    )} */}
                  </h3>

                  <div
                    className="features-list"
                    style={{ listStyle: 'none', marginBottom: '10px' }}
                  >
                    {template.features.map((feature) => formatFeature(feature))}
                  </div>
                </div>
                <Button
                  color="primary"
                  onClick={() => navigate(template.link)} // Use navigate instead of href
                  style={{ marginTop: '-70px' }}
                >
                  Get Started
                </Button>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
      <style>
        {`
         .custom-card {
          position: relative;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 20px;
          padding: 20px;
          backdrop-filter: blur(10px);
          box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .custom-card:hover {
          transform: translateY(-10px) scale(1.03);
          box-shadow: 0px 15px 40px rgba(0, 0, 0, 0.2);
        }

        .card-header {
          text-align: center;
          margin-bottom: 10px;
          padding: 0%;
        }

        .choose-card-title {
          font-size: 1.5rem;
          color: #222;
          font-weight: bold;
        }


        /* Mobile Responsiveness */
        @media (max-width: 768px) {
          .custom-card {
            padding: 15px;
          }

          .choose-card-title {
            font-size: 1.2rem;
          }

          .action-button {
            padding: 10px 20px;
            font-size: 0.9rem;
          }
        }
        `}
      </style>
    </>
  );
};

export default ChooseTemplateBuilder;
